import React from 'react';
import { Menu, MenuItem } from '@mui/material';
import Can from '../permissions/Can';

const LeadActionsMenu = ({
  anchorEl,
  selectedLead,
  onClose,
  onViewLead,
  onEditLead,
  onCreateOrder,
  onOpenStatusDialog,
  onOpenAssignDialog,
  onOpenShareDialog,
  onOpenAttachmentsDialog,
  onOpenIssueDialog,
  onOpenAssignedUsersDialog,
  onDeleteLead,
}) => {
  const handleView = () => {
    onViewLead(selectedLead.id);
    onClose();
  };

  const handleEdit = () => {
    onEditLead(selectedLead.id);
    onClose();
  };

  const handleDelete = () => {
    onDeleteLead(selectedLead);
    onClose();
  };

  return (
    <Menu
      anchorEl={anchorEl}
      open={Boolean(anchorEl)}
      onClose={onClose}
    >
      <Can permission="lead-view">
        <MenuItem onClick={handleView}>View</MenuItem>
      </Can>
      <Can permission="lead-edit">
        <MenuItem onClick={handleEdit}>Edit</MenuItem>
      </Can>
      {typeof onCreateOrder === 'function' && selectedLead?.id && (
        <MenuItem
          onClick={() => {
            onCreateOrder(selectedLead);
            onClose();
          }}
        >
          Create order
        </MenuItem>
      )}
      <Can permission="lead-status">
        <MenuItem onClick={onOpenStatusDialog}>Change Status</MenuItem>
      </Can>
      <Can permission="lead-assign-user">
        <MenuItem onClick={onOpenAssignDialog}>Assign to User</MenuItem>
      </Can>
      <Can permission="shareable-link-create">
        <MenuItem onClick={onOpenShareDialog}>Add Shareable URL</MenuItem>
      </Can>
      <Can permission="attachment-view">
        <MenuItem onClick={onOpenAttachmentsDialog}>Show All Attachments</MenuItem>
      </Can>
      <Can permission="lead-assigned-users-list">
        <MenuItem onClick={onOpenAssignedUsersDialog}>Assigned Users History</MenuItem>
      </Can>
      <Can permission="issue-create">
        <MenuItem onClick={onOpenIssueDialog}>Add An Issue</MenuItem>
      </Can>
      <Can permission="lead-delete">
        <MenuItem onClick={handleDelete} sx={{ color: 'error.main' }}>
          Delete
        </MenuItem>
      </Can>
    </Menu>
  );
};

export default LeadActionsMenu;
